import { useCallback } from 'react'
import { useLocation } from 'react-router'
import { useNavigate } from '../app/scope'

/** What the form leaves in the history entry of a document it has just submitted */
export const justSubmitted = { submitted: true } as const

/**
 * Whether the document on this page was submitted here and now (the form's "Submit" brought us to it), so the page may
 * follow on from it — the sender signing the bill they just booked. `done` forgets it: a reload or a way back to the
 * page does not follow on again
 */
export function useJustSubmitted() {
  const location = useLocation()
  const navigate = useNavigate()
  const just = (location.state as typeof justSubmitted | null)?.submitted === true
  const done = useCallback(
    () => navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: null }),
    [navigate, location.pathname, location.search],
  )
  return { just, done }
}
